var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.87,
    height: 19.467,
    viewBox: "-828 1108 25.87 19.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-823.688 1108c-2.383 0-4.312 1.952-4.312 4.363v10.74c0 2.412 1.929 4.364 4.312 4.364h17.246c2.383 0 4.312-1.952 4.312-4.363v-10.74c0-2.412-1.93-4.364-4.312-4.364h-17.246Zm0 .671h17.246c2.027 0 3.648 1.641 3.648 3.692v10.74c0 2.052-1.621 3.693-3.648 3.693h-17.246c-2.027 0-3.649-1.641-3.649-3.692v-10.74c0-2.052 1.622-3.693 3.649-3.693Zm5.586 4.364a.334.334 0 0 0-.28.324v8.727a.335.335 0 0 0 .487.304l7.96-4.363a.336.336 0 0 0 0-.598l-7.96-4.363a.328.328 0 0 0-.207-.032Zm.384.891 6.923 3.797-6.923 3.807v-7.604Z",
    fillRule: "evenodd",
    "data-name": "Path 641"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.31dbe1fdd9633aafef54ee528591a78f.svg";
export { ForwardRef as ReactComponent };